import { AxiosResponse } from "axios";
import { axiosRequest } from "../api.utils";
import { API_ROOT } from "services/baseURLs.config";
import {
  CreditBalance,
  GetCreditQueryParams,
  CreditDepositsResponse,
  CreditWithdrawalsResponse,
} from "model/TipCredit";

const getCreditDeposits = async (
  companyId: number,
  params?: GetCreditQueryParams
): Promise<AxiosResponse<CreditDepositsResponse>> => {
  return await axiosRequest.auth.get(
    `${API_ROOT}/companies/${companyId}/credits/deposits`,
    {
      params: {
        page: 0,
        pageSize: 20,
        ...params,
      },
    }
  );
};

const getCreditWithdrawals = async (
  companyId: number,
  params?: GetCreditQueryParams
): Promise<AxiosResponse<CreditWithdrawalsResponse>> => {
  return await axiosRequest.auth.get(
    `${API_ROOT}/companies/${companyId}/credits/withdrawals`,
    {
      params: {
        page: 0,
        pageSize: 20,
        ...params,
      },
    }
  );
};

const getCreditBalance = async (
  companyId: number
): Promise<AxiosResponse<CreditBalance>> => {
  return await axiosRequest.auth.get<CreditBalance>(
    `${API_ROOT}/companies/${companyId}/credits/balance`
  );
};

export const companyCredits = {
  getCreditDeposits,
  getCreditWithdrawals,
  getCreditBalance,
};
